import { useMemo } from 'react';
import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Common/Util/getMonthsByYear';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useUtilizationPerMonthPerYearAverageChart = () => {
    const { chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = useMemo(
        () =>
            ['Média Anual do Total de Utilização Mensal'].map((item) => {
                const data = months.map((month) => {
                    const found = chartData.averageSelectedYear.find(
                        (counter) =>
                            parseInt(counter.mes_competencia, 10) ===
                            monthsIndexes[month]
                    );

                    return found ? Number(found.average).toFixed(0) : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData, months]
    );

    return {
        series,
        subtitles: months
    };
};

export default useUtilizationPerMonthPerYearAverageChart;
